var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdhBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9178 48.3651C14.4554 49.7452 4.56517 45.605 1.3887 35.1376C-2.2713 23.2938 1.25852 7.87534 12.5101 2.49283C26.3095 -3.83823 45.1116 6.65154 47.8231 22.773C49.735 37.3397 35.7756 47.1934 23.9215 48.3614",
    fill: "#FEC508"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7794_13221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 32,
    height: 32
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9H8V41H40V9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7794_13221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7794_13221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 9,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9H8V41H40V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7794_13221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5189 36.1374C17.5189 36.6456 17.9393 37.066 18.4475 37.066H31.4295C31.9377 37.066 32.3581 36.6519 32.3581 36.1374V15.9585C32.3581 15.4503 31.9377 15.0299 31.4295 15.0299V35.2087C31.4295 35.717 31.0091 36.1374 30.5008 36.1374H17.5189ZM24.7345 26.713C24.7345 27.4723 24.1134 28.175 22.9526 28.175C22.0491 28.175 21.1706 27.7044 20.6373 26.6001L19.6396 27.4095C20.2357 28.677 21.4028 29.3232 22.6138 29.4299V30.7726H23.5989V29.3923C25.0985 29.1664 26.1777 28.1123 26.1777 26.6252C26.1777 25.615 25.6569 24.8809 24.8098 24.3601C24.1259 23.946 22.9463 23.4566 22.4255 23.1366C21.9738 22.8605 21.5785 22.4589 21.5785 21.8503C21.5785 21.0409 22.2561 20.5326 23.1032 20.5326C23.7432 20.5326 24.4773 20.8087 25.0608 21.5868L25.9644 20.7334C25.3495 19.8989 24.5401 19.4723 23.7056 19.3217V18.073H22.7205V19.2903C21.1518 19.4534 20.1542 20.5389 20.1542 21.9256C20.1542 22.9672 20.7503 23.7075 21.6161 24.2534C22.2561 24.6675 23.0655 24.9687 23.7181 25.3201C24.264 25.6275 24.7283 26.0228 24.7283 26.7005L24.7345 26.713ZM14.7393 35.2087V18.0542H18.9118C19.9346 18.0542 20.7691 17.226 20.7691 16.197V12.0244H30.5071C31.0153 12.0244 31.4357 12.4385 31.4357 12.953V14.1013C32.4585 14.1013 33.293 14.9295 33.293 15.9585V36.1374C33.293 37.1601 32.4647 37.9946 31.4357 37.9946H18.4538C17.431 37.9946 16.5965 37.1664 16.5965 36.1374H15.6679C15.1596 36.1374 14.7393 35.7232 14.7393 35.2087ZM18.9118 17.1256H15.2036L19.8404 12.4887V16.197C19.8404 16.7052 19.4201 17.1256 18.9118 17.1256Z",
    fill: "#00625F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdhBusinessIcon);
export default __webpack_public_path__ + "static/media/idh-business-icon.7793b3bb50ea2f66373eb3c810bf5f97.svg";
export { ForwardRef as ReactComponent };